
/**
 * Returns the current date in local YYYY-MM-DD format.
 * This is used for streaks and daily challenges to ensure they follow the user's local day
 * rather than UTC midnight, preventing boundary bugs where early/late plays skip or double UTC days.
 */
export const getLocalCalendarDay = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Calculates the difference in calendar days between two YYYY-MM-DD strings.
 * Accounts for DST and other local variations by treating both as local midnights.
 */
export const getDayDiff = (date1, date2) => {
    if (!date1 || !date2) return 0;

    // Create dates as local midnights
    const d1 = new Date(date1 + 'T00:00:00');
    const d2 = new Date(date2 + 'T00:00:00');

    const diffTime = Math.abs(d2 - d1);
    // Use round to handle DST shifts (+/- 1 hour)
    return Math.round(diffTime / (1000 * 60 * 60 * 24));
};
